import { Injectable } from "@angular/core";
import { Constants } from "../utils/constants";
import { environment } from "../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { map } from 'rxjs/operators';
import { ApiResponse } from "../classes/api-response";
import { Storage } from "../model/storage";

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  private readonly entities = Constants.entities;
  private readonly crtlPathFragment = this.entities.storage;
  private readonly crtlFullPath = `${environment.apiUrl}/${this.crtlPathFragment}`;

  constructor(private http: HttpClient) {
  }

  public getAllStorage(): Observable<Storage[]> {
    return this.http
      .get<ApiResponse>(`${this.crtlFullPath}`)
      .pipe(map(value => value.data as Storage[]));
  }

  public getStorage(id: number): Observable<Storage> {
    return this.http
      .get<ApiResponse>(`${this.crtlFullPath}/${id}`)
      .pipe(map(value => value.data as Storage));
  }

  public createStorage(storage: Storage): Observable<Storage> {
    return this.http
      .post<ApiResponse>(`${this.crtlFullPath}`, storage)
      .pipe(map(value => value.data as Storage));
  }


  public updateStorage(storage: Storage): Observable<void> {
    return this.http
      .patch<ApiResponse>(`${this.crtlFullPath}/${storage.id}`, storage)
      .pipe(map(() => { }));
  }

  public deleteStorage(id: number): Observable<void> {
    return this.http
      .delete<ApiResponse>(`${this.crtlFullPath}/${id}`)
      .pipe(map(() => { }));
  }
}
